import React from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";

import Diseases from "./Diseases";
import Medications from "./Medications";
import APIMaintenance from "../APIMaintenance";
import MedicationsInfo from "../disease-fund-detail/MedicationsInfo";

export default function FundMedicationListing({
  maintenance,
  maintenanceMessageLine1,
  maintenanceMessageLine2,
  titlesMap = {},
}) {
  return (
    <div>
    {!maintenance && <Diseases titlesMap={titlesMap} />}
    {maintenance && (
      <div
        className="Card u-mt8 u-mb8"
        style={{
          maxWidth: "640px",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <div className="Card-inner">
          <div className="Card-inner-content">
            <APIMaintenance
              line1={maintenanceMessageLine1}
              line2={maintenanceMessageLine2}
            />
          </div>
        </div>
      </div>
    )}
    </div>
  );
}
